class ShiftController implements ng.IComponentController {

    constructor(
    ) {
        'ngInject';
    }

}

export const shiftComponent: ng.IComponentOptions = {
    controller: ShiftController,
    template: <string>require('./shift.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.component.ts